import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';
import { CurrentUserService } from '@core/services';
import { AppRoutesEnum, UserRoleEnum } from '@shared/enums';

@Injectable({ providedIn: 'root' })
export class UserGuard  {
    constructor(private router: Router, private currentUserService: CurrentUserService) {}

    async canActivate(route: ActivatedRouteSnapshot): Promise<boolean> {
        const currentUser = await this.currentUserService.initializeCurrentUser();

        if (currentUser) {
            return this.checkAccess(this.currentUserService.getCurrentUserRole(), route.data['roles'] || []);
        }
        return false;
    }

    checkAccess(role: UserRoleEnum, access: UserRoleEnum[]): boolean {
        if (access.findIndex(r => r === role) > -1) {
            return true;
        }
        this.router.navigate([AppRoutesEnum.DASHBOARD]);
        return false;
    }
}
